import React,{useState, useEffect} from "react";
import './Wallet.css'
import walletBackground from './../../../../images/walletbackground.png'
import transfericon from './../../../../images/transfericon.png'
import earningsgraph from './../../../../images/earningsgraph.png'
import filtersicon from './../../../../images/filtersicon.png'
import sendicon from './../../../../images/sendmoneyicon.png'
import receiveicon from './../../../../images/receivemoneyicon.png'
import receivepaymenticon from './../../../../images/receivepaymenticon.png'
import sendpaymenticon from './../../../../images/sendpaymenticon.png'
import banktransfericon from './../../../../images/banktransfericon.png'
import paymentinfoicon from './../../../../images/paymentinfobtn.png'
import moreoptionsbtn from './../../../../images/moreoptionbtn.png'
import wallettestgraph from './../../../../images/wallettestgraph.png'
import pendingtransicon from './../../../../images/pendingtransicon.png'
import pendingreceivetrans from './../../../../images/pendingreceivetrans.png'
import sendtransicon from './../../../../images/sendtransicon.png'
import receivetransicon from './../../../../images/receivetransicon.png'
import CrossIcon from './../../../../images/crossicon.png'
import { Trans, useTranslation} from 'react-i18next'
import ReactModal from 'react-modal';
import i18next from "i18next"
import Cookies from 'universal-cookie';

function Wallet() {
    const {t, i18n } = useTranslation();
    const cookies = new Cookies(null ,{ path: '/' });
    const [graphDuration,setGraphDuration] = useState(1);
    const [transDetails,setTransDetails] = useState(false);


    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
    useEffect(()=>{
        topFunction()
    },[])

    function closeTransDetailsPopup(){
        setTransDetails(false)
    }
    
    return (
        <div>
           <div style={{display:'flex',flexDirection:'row'}}>
                <div  style={{display:'flex',flexDirection:'column',width:'50%'}}>

                <div style={{display:'flex',flexDirection:'row',backgroundImage:'linear-gradient(141deg, rgba(54,98,211,1) 0%, rgba(135,95,197,1) 100%)',position:'relative',justifyContent:'space-between',borderRadius:'16px',overflow:'hidden',height:'10em',marginRight:'1em',marginBottom:'1.5em'}}>
   
                    <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
                        <div className="WalletContainerHeader">BALANCE</div>
                        <span className="WalletContainerAmount">$1,682.55 <span style={{fontSize:'1rem',color:'rgba(255,255,255,64%)'}}>USD</span></span>
                        <div className="WalletContainerExtra">available today</div>
                    </div>

                    <div style={{cursor:'pointer',display:'flex',flexDirection:'row',justifyContent:'center',paddingLeft:'1em',paddingRight:'1em',alignItems:'center',border:'1px solid rgba(255,255,255,70%)',height:'3em',alignSelf:'center',marginRight:'2em'}}>
                            <img src={transfericon} style={{width:'1.5em',height:'1.5em'}}/>
                            <div className="FilterTxt">Transfer</div>
                    </div>
                    
                </div>

                <div style={{display:'flex',flexDirection:'column',position:'relative',borderRadius:'16px',overflow:'hidden',marginRight:'1em',paddingBottom:'2.375em',backgroundImage:'linear-gradient(174.92deg, rgba(199, 165, 255, 0.2) 2.03%, rgba(199, 165, 255, 0.08) 91.48%)'}}>
   
                <div style={{display:'flex',flexDirection:'column',marginLeft:'2em'}}>
                    <div className="WalletContainerHeader">EARNINGS THIS MONTH</div>
                    <span className="WalletContainerAmount">$1,483.00 <span style={{fontSize:'1rem',color:'rgba(255,255,255,64%)'}}>USD</span></span>
                    <div className="WalletContainerExtra">$2,503.50 USD all time</div>
                </div>

                <div style={{display:'flex',flexDirection:'row',alignSelf:'center',marginTop:'2em'}}> 
                    <div className={graphDuration===0?"GraphDurationSelected":"GraphDuration"} onClick={()=>setGraphDuration(0)}>Week</div>
                    <div className={graphDuration===1?"GraphDurationSelected":"GraphDuration"} onClick={()=>setGraphDuration(1)}>Month</div>
                    <div className={graphDuration===2?"GraphDurationSelected":"GraphDuration"} onClick={()=>setGraphDuration(2)}>All time</div>
                </div>

                <img src={wallettestgraph} style={{marginTop:'2.81em'}}/>

                </div>

                </div>

                <div  style={{display:'flex',flexDirection:'column',width:'50%',position:'relative',borderRadius:'16px',overflow:'hidden',backgroundImage:'linear-gradient(174.92deg, rgba(199, 165, 255, 0.2) 2.03%, rgba(199, 165, 255, 0.08) 91.48%)'}}>

                <div style={{display:'flex',flexDirection:'row',width:'90%',paddingLeft:'2em',paddingRight:'2em',paddingTop:'2em',alignItems:'flex-start',justifyContent:'space-between'}}>
                    <div className="WalletContainerHeader" style={{marginTop:'0em'}}>TRANSACTIONS</div>
                   

                </div>

                <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',cursor:'pointer',borderRadius:'2px',border:'1px solid rgba(255,255,255,70%)',width:'6.625em',paddingTop:'0.625em',paddingBottom:'0.625em',position:'absolute',top:'2em',right:'2em'}}>
                        <img src={filtersicon} style={{marginRight:'0.625em'}}/>
                        <div className="FilterTxt">Filter</div>
                    </div>
                {/* <div style={{display:'flex',flexDirection:'column',position:'relative',borderRadius:'16px',overflow:'hidden',height:'10em',marginRight:'1em',paddingLeft:'2em',paddingRight:'2em'}}>
   
                <div style={{display:'flex',flexDirection:'row',zIndex:'2',width:'100%', backgroundColor:'pink'}}>
                    <div className="WalletContainerHeader">TRANSACTIONS</div>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',cursor:'pointer',borderRadius:'2px',border:'1px solid rgba(255,255,255,70%)',maxWidth:'6.625em',paddingTop:'0.625em',paddingBottom:'0.625em',alignSelf:'flex-end'}}>
                        <img src={filtersicon} style={{marginRight:'0.625em'}}/>
                        <div className="FilterTxt">Filter</div>
                    </div>
                </div>
                </div> */}

                <div className="TransactionFilterHeader" style={{marginTop:'2.187em'}}>
                    Recent
                </div>

                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}} onClick={()=>setTransDetails(true)}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={pendingtransicon} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">CHASE Checking</div>
                           
                            <span className="TransStatus"><span style={{color:'#FFCF71'}}>Pending to send</span> · July 11, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#FF8686'}}>
                        - $600
                    </div>
                </div>

                
                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={pendingreceivetrans} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">CHASE Checking</div>
                           
                            <span className="TransStatus"><span style={{color:'#FFCF71'}}>Pending to receive</span> · July 11, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#60E5C5'}}>
                        + $300
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={receivetransicon} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">Royalty</div>
                           
                            <span className="TransStatus"><span>Received</span> · July 12, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#60E5C5'}}>
                        + $100
                    </div>
                </div>

                <div className="TransactionFilterHeader" style={{marginTop:'1.5em'}}>
                   All transactions
                </div>

                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={receivetransicon} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">Royalty</div>
                           
                            <span className="TransStatus"><span>Received</span> · July 12, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#60E5C5'}}>
                        + $132.90
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={receivetransicon} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">Royalty</div>
                           
                            <span className="TransStatus"><span>Received</span> · July 12, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#60E5C5'}}>
                        + $132.90
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={sendtransicon} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">CHASE Checking</div>
                           
                            <span className="TransStatus"><span>Sent</span> · May 28, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#FF8686'}}>
                        - $600
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={receivetransicon} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">Royalty</div>
                           
                            <span className="TransStatus"><span>Received</span> · July 15, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#60E5C5'}}>
                        + $100
                    </div>
                </div>

                <div style={{display:'flex',flexDirection:'row',marginLeft:'2em',marginRight:'2em',marginTop:'1em',marginBottom:'1em',alignItems:'center',justifyContent:'space-between'}}>
                    <div style={{display:'flex',flexDirection:'row'}}>
                        <img src={sendtransicon} style={{width:'2.5em',height:'100%',marginRight:'1em'}}/>
                        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between'}}>
                            <div className="TransHeader">CHASE Checking</div>
                           
                            <span className="TransStatus"><span>Sent</span> · May 28, 2024</span>
         
                        </div>
                    </div>

                    <div className="TransPrice" style={{ color:'#FF8686'}}>
                        - $100
                    </div>
                </div>


               
                </div>
           </div>

           <ReactModal
          isOpen={transDetails}
          overlayClassName="Overlay"
          contentLabel="Example Modal"
          onRequestClose={closeTransDetailsPopup} // closes the modal when the user presses the escape key
          shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
          style={{
            content:{
              width:'34.125em',
              height:'27.25em',
              margin:'auto',
              backgroundImage:'linear-gradient(190deg, rgba(24,32,40,1) 0%, rgba(39,54,68,1) 100%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              justifyContent:'flex-start',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,15%)'
            }
          }}
        >
     
          <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setTransDetails(false)}/>
          
          <img src={receivetransicon} style={{width:'3.25em',height:'3.25em',marginTop:'2.5em'}}/>
          <div className="TransPopupHeader" style={{marginTop:'0.57em'}}>Royalty</div>
          <div className="TransPopupHeader" style={{marginTop:'0.285em',color:'#60E5C5'}}>+ $132.90</div>

          <div style={{display:'flex',flexDirection:'column',width:'58.60%',marginTop:'2em',marginBottom:'3em'}}>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',marginBottom:'1em'}}>
                    <div className="TransPopupTitle">Time</div>
                    <div className="TransPopupDesc">June 15, 2024, 8:15 pm PST</div>
                </div>

                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',marginBottom:'1em'}}>
                    <div className="TransPopupTitle">Status</div>
                    <div className="TransPopupDesc">Received</div>
                </div>

                <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                    <div className="TransPopupTitle">Transaction ID</div>
                    <div className="TransPopupDesc">391492052</div>
                </div>
          </div>

          <div style={{display:'flex',flexDirection:'row'}}>
                    <div className="TransPopupDesc" style={{marginRight:'0.5em'}}>Questions?</div>
                    <div className="TransPopupDesc" style={{color:'#C7A5FF',cursor:'pointer'}}>Contact Us</div>
            </div>
        </ReactModal>
            
        </div>
       
    );
}

export default Wallet;

{/* <div style={{display:'flex',flexDirection:'row'}}>
<div style={{display:'flex',flexDirection:'row',position:'relative',justifyContent:'space-between',borderRadius:'16px',overflow:'hidden',width:'34.25em',height:'10em',marginRight:'1em'}}>
   
    <div style={{display:'flex',flexDirection:'column',marginLeft:'2em',zIndex:'2'}}>
        <div className="WalletContainerHeader">BALANCE</div>
        <span className="WalletContainerAmount">$1,682<span>.55 USD</span></span>
        <div className="WalletContainerExtra">available today</div>
    </div>

    <div style={{cursor:'pointer',display:'flex',flexDirection:'row',justifyContent:'center',paddingLeft:'1em',paddingRight:'1em',zIndex:'2',alignItems:'center',border:'1px solid rgba(255,255,255,70%)',height:'3em',alignSelf:'center',marginRight:'2em'}}>
            <img src={transfericon} style={{width:'1.5em',height:'1.5em'}}/>
            <div className="FilterTxt">Transfer</div>
    </div>
    <img src={walletBackground} style={{position:'absolute',zIndex:'1'}}/>
</div>

<div style={{display:'flex',flexDirection:'row',position:'relative',justifyContent:'space-between',borderRadius:'16px',overflow:'hidden',width:'34.25em',height:'10em',marginRight:'1em'}}>
    <div style={{display:'flex',flexDirection:'column',marginLeft:'2em',zIndex:'2'}}>
        <div className="WalletContainerHeader">EARNINGS THIS MONTH</div>
        <span className="WalletContainerAmount">$1483<span>.00 USD</span></span>
        <div className="WalletContainerExtra">$2,503.50 USD all time</div>
    </div> 

    <img src={earningsgraph} style={{width:'10.84em',height:'4.8em',backgroundColor:'rgba(0,0,0,8%)',zIndex:'2',alignSelf:'center',marginRight:'2em'}}/>
    <img src={walletBackground} style={{position:'absolute',zIndex:'1'}}/>
</div>
</div>

<div style={{display:'flex',position:'relative',flexDirection:'column',backgroundColor:'rgba(255,255,255,5%)',borderRadius:'8px',marginTop:'1.5em',paddingLeft:'2em'}}>
<div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',cursor:'pointer',borderRadius:'2px',border:'1px solid rgba(255,255,255,70%)',maxWidth:'6.625em',paddingTop:'0.625em',paddingBottom:'0.625em',position:'absolute',top:'1em',right:'1.5em',width:'6.625em'}}>
<img src={filtersicon} style={{marginRight:'0.625em'}}/>
<div className="FilterTxt">Filter</div>
</div>
<div className="TransactionsTxt">TRANSACTIONS</div>

<div className="TransactionsTableTime">
Last month
</div>

<div className="MoneyTransactionListItem">
        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
            <img src={banktransfericon} style={{width:'2.3em',height:'2.3em',marginRight:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                <div className="TransactionName">
               Bank Transfer
                </div>
                <div className="TransactionDate">
              Jul 17, 2024
                </div>
            </div>

        </div>

        <div className="TransactionType" style={{fontStyle:'italic'}}>
        Pending
        </div>

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
        {
                    cookies.get('lang') === 'en' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                $100.00
            </div>
        }
        {
                    cookies.get('lang') === 'jp' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                19378円
            </div>
        }

            <img src={paymentinfoicon} style={{width:'0.9em',height:'1.3em',marginLeft:'1.7em',cursor:'pointer'}}/>

        </div>

        



</div>

<div className="MoneyTransactionListItem">
<div style={{display:'flex',flexDirection:'row',width:'30%'}}>
            <img src={receivepaymenticon} style={{width:'2.3em',height:'2.3em',marginRight:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                <div className="TransactionName">
               Royalty payment
                </div>
                <div className="TransactionDate">
              Jul 17, 2024
                </div>
            </div>

        </div>

        <div className="TransactionType">
        Recieved
        </div>

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
        {
                    cookies.get('lang') === 'en' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                $132.90
            </div>
        }
        {
                    cookies.get('lang') === 'jp' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                19378円
            </div>
        }

            <img src={paymentinfoicon} style={{width:'0.9em',height:'1.3em',marginLeft:'1.7em',cursor:'pointer'}}/>

        </div>
</div>

<div className="TransactionsTableTime">
All transactions
</div>

<div className="MoneyTransactionListItem">
<div style={{display:'flex',flexDirection:'row',width:'30%'}}>
            <img src={receivepaymenticon} style={{width:'2.3em',height:'2.3em',marginRight:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                <div className="TransactionName">
               Royalty payment
                </div>
                <div className="TransactionDate">
             Yesterday
                </div>
            </div>

        </div>

        <div className="TransactionType">
        Recieved
        </div>

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
        {
                    cookies.get('lang') === 'en' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                $132.90
            </div>
        }
        {
                    cookies.get('lang') === 'jp' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                19378円
            </div>
        }

            <img src={paymentinfoicon} style={{width:'0.9em',height:'1.3em',marginLeft:'1.7em',cursor:'pointer'}}/>

        </div>
</div>

<div className="MoneyTransactionListItem">
        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
            <img src={banktransfericon} style={{width:'2.3em',height:'2.3em',marginRight:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                <div className="TransactionName">
               Bank Transfer
                </div>
                <div className="TransactionDate">
              August 10
                </div>
            </div>

        </div>

        <div className="TransactionType" style={{fontStyle:'italic'}}>
        Deposited
        </div>

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
        {
                    cookies.get('lang') === 'en' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                $100.00
            </div>
        }
        {
                    cookies.get('lang') === 'jp' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                19378円
            </div>
        }

            <img src={paymentinfoicon} style={{width:'0.9em',height:'1.3em',marginLeft:'1.7em',cursor:'pointer'}}/>

        </div>

        



</div>

<div className="MoneyTransactionListItem">
        <div style={{display:'flex',flexDirection:'row',width:'30%'}}>
            <img src={sendpaymenticon} style={{width:'2.3em',height:'2.3em',marginRight:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                <div className="TransactionName">
               Merchant Payment
                </div>
                <div className="TransactionDate">
              July 2
                </div>
            </div>

        </div>

        <div className="TransactionType" style={{fontStyle:'italic'}}>
       Sent
        </div>

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
        {
                    cookies.get('lang') === 'en' &&
            <div className="TransactionAmount" style={{color:"#FF8686"}}>
                -$49.90
            </div>
        }
        {
                    cookies.get('lang') === 'jp' &&
            <div className="TransactionAmount" style={{color:"#FF8686"}}>
                -19378円
            </div>
        }

            <img src={paymentinfoicon} style={{width:'0.9em',height:'1.3em',marginLeft:'1.7em',cursor:'pointer'}}/>

        </div>

        



</div>

<div className="MoneyTransactionListItem">
<div style={{display:'flex',flexDirection:'row',width:'30%'}}>
            <img src={receivepaymenticon} style={{width:'2.3em',height:'2.3em',marginRight:'1em'}}/>

            <div style={{display:'flex',flexDirection:'column',marginTop:'-0.3em'}}>
                <div className="TransactionName">
               Royalty payment
                </div>
                <div className="TransactionDate">
               June 30
                </div>
            </div>

        </div>

        <div className="TransactionType">
        Recieved
        </div>

        <div style={{display:'flex',flexDirection:'row',alignItems:'center',width:'20%',alignContent:'flex-end',justifyContent:'flex-end'}}>
        {
                    cookies.get('lang') === 'en' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                $32.90
            </div>
        }
        {
                    cookies.get('lang') === 'jp' &&
            <div className="TransactionAmount" style={{color:"#60E5C5"}}>
                19378円
            </div>
        }

            <img src={paymentinfoicon} style={{width:'0.9em',height:'1.3em',marginLeft:'1.7em',cursor:'pointer'}}/>

        </div>
</div>

</div> */}